import { render, staticRenderFns } from "./AppInput.vue?vue&type=template&id=70b58048&scoped=true"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"
import style0 from "./AppInput.vue?vue&type=style&index=0&id=70b58048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b58048",
  null
  
)

export default component.exports